import { footerColumns } from '@/mocks/home';

export default function SiteFooter() {
  return (
    <footer className="border-t border-secondary-200 bg-secondary-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-14 xl:px-10">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-sm font-bold text-background-50">
                15
              </span>
              <span className="font-heading text-base font-bold text-foreground-950">15黑料网</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              人物黑料档案集中呈现公众人物黑历史、负面事件与争议合集，按热度持续更新，并按人物索引整理完整事件脉络与多方信源。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-mail-line', 'ri-rss-line'].map((icon) => (
                <a
                  key={icon}
                  href="#subscribe"
                  aria-label="关注渠道"
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-secondary-200 bg-background-50 text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
                >
                  <i className={`${icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:col-span-8">
            {footerColumns.map((column) => (
              <div key={column.title}>
                <h4 className="font-heading text-sm font-bold text-foreground-950">
                  <a href="#top" className="cursor-pointer">
                    {column.title}
                  </a>
                </h4>
                <ul className="mt-4 flex flex-col gap-3">
                  {column.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="whitespace-nowrap font-label text-sm text-foreground-600 transition-colors hover:text-primary-600"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 border-t border-secondary-200 pt-6">
          <p className="text-xs leading-relaxed text-foreground-500">
            免责声明：本站内容为编辑整理与读者投稿，旨在呈现公开信息与多方说法，不代表对任何个人的结论性判断。如相关内容涉及事实错误或权益问题，可通过更正通道联系我们优先复核处理。
          </p>
          <div className="mt-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <p className="font-label text-xs text-foreground-500">
              © 2026 15黑料网 · 人物黑料档案与黑历史合集
            </p>
            <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
              <a href="#trust" className="font-label text-xs text-foreground-500 hover:text-primary-600">
                信源与核实说明
              </a>
              <a href="#faq" className="font-label text-xs text-foreground-500 hover:text-primary-600">
                常见问题
              </a>
              <a href="#top" className="font-label text-xs text-foreground-500 hover:text-primary-600">
                回到顶部
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}